import { WikipediaPage } from '../../Widget/Social/types';
import { WikipediaCard } from '../../Widget/Social/WikipediaCard';

export const WikipediaPages = ({
  wikipediaPages,
}: {
  wikipediaPages: WikipediaPage[];
}) => (
  <div className={'grid gap-4 grid-cols-2 p-4'}>
    {wikipediaPages.map((item) => (
      <WikipediaCard post={item} key={item.id} />
    ))}
  </div>
);
